import CloseIcon from '@mui/icons-material/Close';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {
  Box,
  Drawer,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { MyContext } from 'Context';
import { useAuthMe } from 'queries/AuthQueries';
import type { FC } from 'react';
import React, { useContext } from 'react';

import SelectuserLogin from '../Common/SelectUserLogin';

const DrawerCard: FC<{
  isOpen: boolean;
  handleClose: () => void;
  width?: number;
  handleLogout: any;
  handleNavigate: any;
  isProfileImage: boolean;
  imageLink: string;
}> = ({
  isOpen,
  handleClose,
  width,
  handleLogout,
  handleNavigate,
  isProfileImage,
  imageLink,
}) => {
  console.log(imageLink);
  const { data: profile } = useAuthMe();
  const theme: any = useTheme();
  const underSm = useMediaQuery(theme.breakpoints.down('md'));
  const { dependentsList, setDependentsList } = useContext(MyContext);
  return (
    <Drawer className="no-radius relative" anchor="right" open={isOpen}>
      <Box sx={{ width: width || '300px' }} className="">
        <div className="flex items-center justify-between p-2">
          {/* <Typography fontSize={20} fontWeight={600}>
            {profile?.data?.firstName} {profile?.data?.lastName}
          </Typography> */}
          <Typography variant="body1" color="initial"></Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize="large" className="text-primary-500" />
          </IconButton>{' '}
        </div>
        <div className="px-2 py-3">
          {/* <div>
            {' '}
            {profile?.data?.roles?.includes('patient') ? (
              <div
                className={`mx-[7px] mb-2 flex cursor-pointer rounded-lg bg-primary-100  p-2`}
              >
                <div
                  className={
                    underSm
                      ? 'm-0 flex h-8 w-[250px] cursor-pointer items-center gap-4'
                      : 'cursor-pointer'
                  }
                  onClick={() => {
                    handleNavigate({
                      name: 'Requests',
                      redirectLink: '/requests',
                    });
                    handleClose();
                  }}
                >
                  <PatientsRequestSelected />{' '}
                  <Typography fontSize={18}>Request</Typography>
                </div>
              </div>
            ) : (
              <div
                className={`mx-[7px]  flex cursor-pointer rounded-lg bg-primary-100  p-2`}
              >
                <div
                  className={
                    underSm
                      ? 'm-0 flex h-8 w-[250px] cursor-pointer items-center gap-4'
                      : 'cursor-pointer'
                  }
                  onClick={() => {
                    handleNavigate({
                      name: 'Inbox',
                      redirectLink: '/inbox',
                    });
                    handleClose();
                  }}
                >
                  <InboxSelectedIcon />{' '}
                  <Typography fontSize={18}>Inbox</Typography>
                </div>
              </div>
            )}
          </div> */}

          {/* <div className="h-8 w-8 rounded-[100%] border-[2px] border-solid border-primary-400">
            <img
              src={imageLink}
              alt="user-profile"
              className="h-full w-full rounded-full"
            />
          </div> */}
          <SelectuserLogin
            username={profile?.data?.username}
            dependents={dependentsList}
            imageLink={imageLink}
            isProfileImage={isProfileImage}
          />

          <div className="absolute bottom-0">
            {' '}
            <div
              className={`m-[7px] flex cursor-pointer items-center rounded-lg bg-primary-100  p-2`}
            >
              <div
                className={
                  underSm
                    ? 'm-0 flex h-8 w-[250px] cursor-pointer items-center justify-center gap-4'
                    : 'cursor-pointer'
                }
                onClick={handleLogout}
              >
                <ExitToAppIcon fontSize="large" className="text-primary-500" />{' '}
                <Typography fontSize={18} fontWeight={600}>
                  Logout
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Drawer>
  );
};

export default DrawerCard;
